export const groupIdMixin = {
  data() {
    return {
      group_id: localStorage.getItem("group_id"),
    };
  },
};
